import { secondaryProductsApiConnector } from 'apiConnector/secondary-market/product-search/searchProductsByCode';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
///////////////////////////////////////////////////
import { catchError, map, mergeMap } from 'rxjs/operators';
import {
  secondaryMarketProductsColumnsFetched,
  secondaryMarketProductsColumnsFetchFailed,
} from 'state/secondaryMarket/productSearch';
import type { EpicWithThunk } from 'state/state.common';

export function fetchColumnsDefinitionsEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) => {
    const api = secondaryProductsApiConnector(httpClient);
    return actions$.pipe(
      ofType('SECONDARY_MARKET_PRODUCT_COLUMNS_FETCHING'),
      mergeMap(() => api.fetchColumnDefinition().pipe(map(res => secondaryMarketProductsColumnsFetched(res)))),
      catchError(err => of(secondaryMarketProductsColumnsFetchFailed(err))),
    );
  };
}
